import React from "react";
import { ApplicationFrameStepType } from "../../types";
import { fvioEvrValidation } from "csv-package";

import ExistingOrder from "./components/ExistingOrder";
import ApplicationType from "./components/ApplicationType";
import Review from "./components/Review";
import Confirm from "./components/Confirm";
import Applicant from "./components/Applicant";
import ProtectedPersons from "./components/ProtectedPersons";
import Respondent from "./components/Respondent";
import ApplicationDetails from "./components/ApplicationDetails";
// import YourRole from "./components/YourRole";
// import PrivacyStatement from "./components/PrivacyStatement";

const steps: ApplicationFrameStepType[] = [
  // {
  //   name: "Your role",
  //   validation: fvioEvrValidation.yourRole,
  //   component: <YourRole />,
  // },
  // {
  //   name: "Privacy statement",
  //   validation: {},
  //   component: <PrivacyStatement />,
  // },
  {
    name: "Applicant",
    validation: fvioEvrValidation.applicant,
    component: <Applicant />,
  },
  {
    name: "Original order",
    validation: fvioEvrValidation.exisitingOrder,
    component: <ExistingOrder />,
  },
  {
    name: "Protected persons",
    validation: fvioEvrValidation.protectedPersons,
    component: <ProtectedPersons />,
  },
  {
    name: "Respondent",
    validation: fvioEvrValidation.respondent,
    component: <Respondent />,
  },
  {
    name: "Application type",
    validation: fvioEvrValidation.applicationType,
    component: <ApplicationType />,
  },
  {
    name: "Application details",
    validation: fvioEvrValidation.applicationDetails,
    component: <ApplicationDetails />,
  },
  {
    name: "Confirm your details",
    validation: {},
    component: <Confirm />,
  },
  {
    name: "Review and submit",
    validation: fvioEvrValidation.review,
    component: <Review />,
  },
];

export default steps;
